export const games = {
    "yx": "게임",
    "yxms": "암호화된 게임에서 모든 결정 결과는 사전에 해시 형식으로 생성되며 어떠한 의지로도 게임 결과를 변경하지 않으므로 절대적으로 공정함을 보장합니다!",
    "mnsm": "모의 플레이",
    "ljqw": "지금 플레이",
    "loading": "로드 중입니다. 잠시 기다려주세요",
    dyh:'선택할 수 있는 다양한 옵션 계약, 100배의 수익, 초고단기 투자 수익률',
    qyhy:'옵션 계약',
    qsyhys:'옵션',
    kd:'주문 열기',
    qt:'취터우',
    ljjy: "지금 거래하세요",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/games/kr.js